/* Aurora 2027 en Shopify — adaptador de rutas.
   La maqueta habla en rutas de archivo (img/trat/x.webp, tratamientos.html?fam=…). Aquí, antes de que
   cualquier HTML entre al DOM, esas rutas se traducen a los assets del tema y a las URLs de Shopify.
   Así el código de la maqueta se usa tal cual y queda una sola fuente de verdad. */
(function(){
"use strict";
const S = window.AU_SHOP, R = S.r, G = S.gmap || {};   // guía nueva -> artículo antiguo que la reemplaza
const conQ = (base, q) => !q ? base : base + (base.includes("?") ? "&" : "?") + q;
function fix(u){
  if (typeof u !== "string" || !u || /^(https?:|\/\/|data:|blob:|mailto:|tel:|#|\/)/.test(u)) return u;
  let m = u.match(/^(?:\.\.\/)?((?:img|video|fonts)\/[^?#]+)(.*)$/);
  if (m) return S.a + m[1].replace(/\//g, "_") + (m[2] ? m[2] + "&" : "?") + "v=" + S.v;   // la versión obliga al CDN a soltar la copia vieja
  m = u.match(/^([a-z0-9-]+)\.html(?:\?([^#]*))?(#.*)?$/);
  if (!m) return u;
  const [, pag, q = "", h = ""] = m, qs = new URLSearchParams(q);
  let base;
  if (pag === "index") base = R.inicio;
  else if (pag === "tratamientos") base = R.trat;
  else if (pag === "tratamiento") { const t = qs.get("t"); qs.delete("t"); base = "/products/" + t; }
  else if (pag === "plan") base = R.plan;
  else if (pag === "arma-tu-depilacion") base = R.arma;
  else if (pag === "guias") base = R.guias;
  else if (pag === "guia") { const g = qs.get("g") || ""; base = R.guias + "/" + (G[g] || g); qs.delete("g"); }
  else if (pag === "carro") base = R.carro;
  else if (pag.startsWith("blog-")) { const g = pag.slice(5); base = R.guias + "/" + (G[g] || g); }
  else return u;
  return conQ(base, qs.toString()) + h;
}
const ATR = /((?:src|href|poster|data-gal|data-src)=")([^"]*)(")|(url\()([^)'"]*)(\))/g;
const fixHTML = s => typeof s !== "string" ? s : s.replace(ATR, (x, a, u, b, c, u2, d) => a ? a + fix(u) + b : c + fix(u2) + d);
window.AU_FIX = fix; window.AU_FIXHTML = fixHTML;

const parchar = (proto, prop, f) => {
  const d = Object.getOwnPropertyDescriptor(proto, prop); if (!d || !d.set) return;
  Object.defineProperty(proto, prop, {configurable:true, enumerable:d.enumerable, get(){ return d.get.call(this); }, set(v){ d.set.call(this, f(v)); }});
};
parchar(Element.prototype, "innerHTML", fixHTML);
parchar(Element.prototype, "outerHTML", fixHTML);
parchar(HTMLImageElement.prototype, "src", fix);
parchar(HTMLMediaElement.prototype, "src", fix);
parchar(HTMLVideoElement.prototype, "poster", fix);
parchar(HTMLAnchorElement.prototype, "href", fix);
parchar(HTMLSourceElement.prototype, "src", fix);
const iah = Element.prototype.insertAdjacentHTML;
Element.prototype.insertAdjacentHTML = function(p, s){ return iah.call(this, p, fixHTML(s)); };
const sa = Element.prototype.setAttribute;
Element.prototype.setAttribute = function(n, v){ return sa.call(this, n, /^(src|href|poster)$/.test(n) ? fix(v) : v); };
["pushState", "replaceState"].forEach(k => { const o = history[k]; history[k] = function(st, t, u){ return o.call(this, st, t, u == null ? u : fix(String(u))); }; });
})();
